import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { UserService } from "../services/user/user.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DialogData } from "../models/dialog-data";
import { ConfirmDialogComponent } from "../material-component/confirm-dialog/confirm-dialog.component";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.css"],
})
export class ChangePasswordComponent implements OnInit {
  oldPassword = new FormControl("", [Validators.required]);
  password = new FormControl("", [Validators.required]);
  retypePassword = new FormControl("", [Validators.required]);
  form: any = {
    oldPassword: null,
    password: null,
    retypePassword: null,
  };
  hidePassword = true;
  isLoading = false;

  constructor(
    private userService: UserService,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<ChangePasswordComponent>
  ) { }

  ngOnInit(): void { }

  onSubmit(): void {
    if (this.password.value === this.retypePassword.value) {
      this.isLoading = true;
      this.userService
        .changePassword({
          oldPassword: this.oldPassword.value,
          newPassword: this.password.value,
        })
        .subscribe(
          () => {
            this.isLoading = false;
            const dialogRef = this.openDialog(
              "Pemberitahuan",
              "Password berhasil diperbarui. Terima kasih"
            );
            dialogRef.afterClosed().subscribe((result) => {
              this.matDialogRef.close();
            });
          },
          (err) => {
            this.isLoading = false;
            let errorMessage =
              "Terjadi kesalahan. Silakan coba beberapa saat lagi. Terima kasih";
            if (err.status === 400 && err.error === "Bad credentials") {
              errorMessage = "Password lama tidak sesuai";
            }
            const dialogRef = this.openDialog("Pemberitahuan", errorMessage);
          }
        );
    } else {
      const dialogRef = this.openDialog(
        "Pemberitahuan",
        "Password Baru tidak sesuai. Periksa kembali password Anda"
      );
    }
  }

  openDialog(title: string, message: string) {
    return this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: title,
        message: message,
        isConfirmation: false,
      },
    });
  }

  getPasswordErrorMessage() {
    if (this.password.hasError("required")) {
      return "Harus diisi";
    }
    return "";
  }
}
